import * as React from 'react';

import Classify16 from './Classify16';

export const classify16 = () => <Classify16 />;

export default {
    title: 'Icon|Fill|Classify16',
    component: Classify16,
    parameters: {
        notes: "`import Classify16 from 'box-ui-elements/es/icon/fill/Classify16';`",
    },
};
